import { useEffect } from 'react';
import AOS from 'aos';
import ProcessStep from '../ui/ProcessStep';
import {
  FaComments,
  FaClipboardList,
  FaPalette,
  FaCode,
  FaBug,
  FaRocket,
  FaTools
} from "react-icons/fa";
import { useLocation } from 'react-router-dom';

const steps = [
  { icon: FaComments, title: 'Requirement Discussion', description: "We'll understand your business goals, features, timeline and budget before starting development." },
  { icon: FaClipboardList, title: 'Planning', description: 'Creating a comprehensive roadmap with timelines, technology stack decisions, and project milestones.' },
  { icon: FaPalette, title: 'UI Design', description: 'Designing user interfaces that align with your brand identity and provide excellent user experience.' },
  { icon: FaCode, title: 'Development', description: 'Building your application with clean, maintainable code following industry best practices.' },
  { icon: FaBug, title: 'Testing', description: 'Rigorous testing to ensure functionality, performance, and security across all devices.' },
  { icon: FaRocket, title: 'Deployment & Ongoing Support', description: 'Deploying your application to production servers with proper configuration and security.' },
  { icon: FaTools, title: 'Support & Maintenance', description: 'Ongoing support, updates, and optimizations to keep your application running smoothly.' },
];

const ProcessSection = () => {
  const location = useLocation()

  useEffect(() => {
    if(location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } 
    }
  }, [location]);

  useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <section className="process-section" id="process">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="service-section-title">Development Process</h2>
          <p className="section-subtitle">
            A structured approach to deliver quality projects on time and within budget.
          </p>
        </div>
        <div className="process-timeline">
          {steps.map((step, index) => (
            <ProcessStep
              key={index}
              number={index + 1}
              icon={step.icon}
              title={step.title}
              description={step.description}
              isLast={index === steps.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
